import "./header.css";

export default function Header() {
  return (
    <div className="header">
     
      <img
        className="headerImg"
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLoUIgLT0oJe3YPvtlGZC7Kehyfh43vf93jA&usqp=CAU"
        alt=""
      />
    </div>
  );
}